export default __webpack_public_path__ + "static/media/Router Online.9794740e.svg";